import React, { useCallback, useEffect, useState } from "react";
import { Send, Eye, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { adminApi, errMsg } from "@/lib/proApi";

const LABEL = { accepted: "Envoyé (accepté par le fournisseur)", failed: "En échec", sending: "Envoi en cours", pending: "En attente" };

export const ReminderPanel = () => {
  const [info, setInfo] = useState(null);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => adminApi.get("/admin/pro/reminder").then(({ data }) => setInfo(data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  if (!info) return null;
  const todo = info.rows.filter((r) => r.send_status !== "accepted").length;
  const sendAll = async () => {
    if (!window.confirm(`Envoyer l'e-mail de rappel à ${todo} compte(s) pro validé(s) ? Les comptes sans code recevront un code créé à cette occasion.`)) return;
    setBusy(true);
    try {
      const { data } = await adminApi.post("/admin/pro/reminder/send-all", { confirm: true });
      setInfo(data);
      toast.success(`${data.accepted} envoyé(s), ${data.failed} en échec, ${data.skipped} déjà envoyé(s)`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section data-testid="reminder-panel" className="rounded-2xl bg-white border border-[var(--oz-border)] p-6">
      <h2 className="font-semibold">Rappel du code -15 % à tous les comptes validés</h2>
      <p className="mt-1 text-sm text-[var(--oz-muted)]">Objet : « {info.subject} » — {info.eligible} compte(s) validé(s), {info.sent} déjà envoyé(s).</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button onClick={() => setShow(!show)} data-testid="reminder-preview-btn" className="inline-flex items-center gap-2 rounded-full border border-[var(--oz-dark)] px-4 py-2 text-sm font-semibold">
          <Eye className="w-4 h-4" /> {show ? "Masquer l'aperçu" : "Voir l'e-mail"}
        </button>
        <button onClick={sendAll} disabled={busy || !todo} data-testid="reminder-send-all-btn" className="inline-flex items-center gap-2 rounded-full bg-[var(--oz-gold)] text-[var(--oz-dark)] px-4 py-2 text-sm font-semibold disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Envoyer à tous ({todo})
        </button>
      </div>
      {show && <iframe title="Aperçu e-mail" data-testid="reminder-preview" srcDoc={info.html} className="mt-4 w-full h-[900px] rounded-xl border border-[var(--oz-border)]" />}
      <ul className="mt-4 divide-y divide-[var(--oz-border)] text-sm" data-testid="reminder-rows">
        {info.rows.map((r) => (
          <li key={r.user_id} data-testid={`reminder-row-${r.user_id}`} className="py-2 flex flex-wrap justify-between gap-2">
            <span><b>{r.company_name}</b> — {r.email} {r.code ? <span className="font-mono text-xs">({r.code})</span> : <span className="text-xs text-[var(--oz-muted)]">(code créé à l'envoi)</span>}</span>
            <span className={`text-xs ${r.send_status === "failed" ? "text-red-600" : "text-[var(--oz-muted)]"}`}>{LABEL[r.send_status] || "Pas encore envoyé"}{r.error ? ` — ${r.error}` : ""}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};
